import { createSlice } from '@reduxjs/toolkit';
import commonFunctions from '../utils/commonFunctions';

export const userSlice = createSlice({
   name: 'user',
   initialState: {
      firstName: '',
      lastName: '',
      id: '',
      email: '',
      phone: '',
      preferences: null
    },
   reducers: {
      // setUserState: (state, action) => {
      //    Object.keys(action.payload).forEach((key)=>{
      //       state[key] = action.payload[key]
      //    })
      // }
      setUserState: (state, action) => {
         if (action.payload) {
            action.payload.preferences = commonFunctions.cleanObject(action.payload.preferences);
            return {
               ...state,
               ...action.payload
            }
         }
         return state
      }
   }
})

export const { setUserState } = userSlice.actions

export default userSlice.reducer